import { createContext, useContext } from 'react';

import { ShipmentWithRelations } from '@/models/shipment';

interface ShipmentContextData {
  shipment: ShipmentWithRelations;
}

export const ShipmentContext = createContext({} as ShipmentContextData);

export const useShipmentContext = () => {
  return useContext(ShipmentContext);
};
